// 로컬 스토리지 키
export const LOCAL_STORAGE_KEY = 'aistudioSelectDatabaseFilters';

// 페이지 사이즈 상수
export const DEFAULT_PAGE_SIZE = 10;

// Search 히스토리 로컬스토리지 키
export const SEARCH_HISTORY_LOCAL_STORAGE_KEY = 'aistudioSearchHistory';

// 최대 검색 히스토리  수
export const MAX_HISTORY_ITEMS = 30;
